import { useMemo, useState } from 'react';
import useSWR from 'swr';
import { discountService } from 'services';
import { useAuth } from 'hooks';
import { FormOption, HistoryContent } from 'types';
import { History, ModalContent, Select } from 'components';
import { addToHistoryList } from 'helpers';
import { DiscountHistoryContent } from './components';

interface Props {
  handleClose: () => void;
}

const HISTORY_FILTER_OPTIONS: FormOption[] = [
  { label: 'Últimos 30 dias', value: '30' },
  { label: 'Últimos 90 dias', value: '90' },
  { label: 'Últimos 365 dias', value: '365' },
];

export function DiscountHistory({ handleClose }: Props) {
  const { selectedStore } = useAuth();
  const { name, brand } = selectedStore;
  const store = name || '';

  const [historyFilter, setHistoryFilter] = useState(
    HISTORY_FILTER_OPTIONS[0].value
  );

  const { data } = useSWR(
    `${brand}-${store}-${historyFilter}-discount-history`,
    () => discountService.getHistory({ store, historyFilter })
  );

  const formattedHistory = useMemo(() => {
    if (!data) return [];

    return data.changeHistory.reduce<HistoryContent[]>((acc, historyEntry) => {
      const content = <DiscountHistoryContent historyEntry={historyEntry} />;

      return addToHistoryList({
        list: acc,
        content,
        date: historyEntry.date,
      });
    }, []);
  }, [data]);

  const selectedOption: FormOption = {
    label: `Últimos ${historyFilter} dias`,
    value: historyFilter,
  };

  return (
    <ModalContent handleClose={handleClose}>
      <div className="flex h-[70vh] min-h-80 sm:min-w-96 flex-col gap-6 p-2 pb-5">
        <h3>Histórico de descontos</h3>

        <div className="flex flex-col gap-1">
          <span className="text-font12">
            Selecione o tempo de consulta do histórico:
          </span>

          <Select.Wrapper
            name="discount"
            initialSelected={selectedOption}
            options={HISTORY_FILTER_OPTIONS}
            searchable={false}
            onChange={(e: any) => {
              setHistoryFilter(e.target.value);
            }}
          >
            <Select.Input value={selectedOption.label} />
            <Select.StatusArrow />
          </Select.Wrapper>
        </div>

        <div className="h-full overflow-y-auto border-t border-solid border-primary-200 pt-6">
          {formattedHistory.length ? (
            <History content={formattedHistory} />
          ) : (
            <span className="text-font12">Nenhum registro encontrado</span>
          )}
        </div>
      </div>
    </ModalContent>
  );
}
